module.exports = __webpack_public_path__ + "img/drug.250162d9.svg";